import { CalendarMode, CalendarModeInitialData } from "PFApp/booking/types";
import React, { useEffect } from "react";

import { useBookingModuleContext } from "../providers/booking_module_context_provider";
import { Toolbar } from "../toolbar";
import { BookingsViewWrapper } from "./bookings_view/bookings_view";
import { useBookingsOverviewContext } from "./context/bookings_overview_context";
import css from "./overview.module.scss";
import { SplitModeWarningOverlay } from "./split_mode_warning_overlay";
import { WorkforceMetrics } from "./workforce_metrics";

type OverviewProps = {
  headerRef: React.MutableRefObject<HTMLDivElement>;
  initialData?: {
    data: CalendarModeInitialData;
    calendarMode: CalendarMode;
  };
};

const Overview = ({ headerRef, initialData }: OverviewProps) => {
  const { calendarMode, setCalendarMode, splitMode } = useBookingsOverviewContext();
  const { headerDisabled } = useBookingModuleContext();

  useEffect(() => {
    if (initialData) {
      const { calendarMode: initCalendarMode, data } = initialData;
      setCalendarMode(initCalendarMode, data);
    }
  }, [initialData]);

  return (
    <div className={css.container}>
      {splitMode && <SplitModeWarningOverlay headerRef={headerRef} />}
      {headerRef?.current && <WorkforceMetrics headerRef={headerRef} disabled={headerDisabled} />}
      <Toolbar
        key={calendarMode} //we need to remount filters when mode changes to repopulate search input default value as it is not controlled
      />
      <BookingsViewWrapper />
    </div>
  );
};

export default Overview;
